// Theme: autumn-night
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'autumn-night',
  name: 'AUTUMN NIGHT',
  tagline: 'AUTUMN NIGHT',
  description: 'Laranja de brasa sobre ferrugem escura em estilo free BP.',
  category: 'organic-world',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#4B1A0E', '#6B2A18', '#F87171', '#FFF5F2'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '16px',
      '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
      '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)'
    },
    shellClasses: 'font-mono theme-autumn-night'
  },
  colorVars: {
    '--accent': '#F87171',
    '--accent-foreground': '#4B1A0E',
    '--background': '#4B1A0E',
    '--border': '#5F2315',
    '--card': '#6B2A18',
    '--card-border-active': 'rgba(248, 113, 113, 0.10)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFF5F2',
    '--card-glow': 'rgba(248, 113, 113, 0.03)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#4B1A0E',
    '--foreground': '#FFF5F2',
    '--hold-fill': '#F87171',
    '--input': '#5F2315',
    '--modal-bg': '#4B1A0E',
    '--modal-border': '#5F2315',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#5F2315',
    '--muted-foreground': '#F8D9D1',
    '--nav-active': '#F87171',
    '--nav-bg': '#6B2A18',
    '--popover': '#6B2A18',
    '--popover-foreground': '#FFF5F2',
    '--primary': '#F87171',
    '--primary-foreground': '#4B1A0E',
    '--ring': '#F87171',
    '--secondary': '#5F2315',
    '--secondary-foreground': '#FFF5F2',
    '--streak': '#F87171',
    '--success': '#22c55e',
    '--success-foreground': '#4B1A0E',
    '--xp': '#F87171',
    '--xp-bg': '#6B2A18'
  },
  resolvedVars: {
    '--accent': '#F87171',
    '--accent-foreground': '#4B1A0E',
    '--accent-foreground-hsl': '12 69% 17%',
    '--accent-foreground-oklch': 'from #4B1A0E l c h',
    '--accent-hsl': '0 91% 71%',
    '--accent-oklch': 'from #F87171 l c h',
    '--background': '#4B1A0E',
    '--background-hsl': '12 69% 17%',
    '--background-oklch': 'from #4B1A0E l c h',
    '--border': '#5F2315',
    '--border-hsl': '11 64% 23%',
    '--border-oklch': 'from #5F2315 l c h',
    '--border-w': '1px',
    '--card': '#6B2A18',
    '--card-border-active': 'rgba(248, 113, 113, 0.10)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFF5F2',
    '--card-foreground-hsl': '14 100% 97%',
    '--card-foreground-oklch': 'from #FFF5F2 l c h',
    '--card-glow': 'rgba(248, 113, 113, 0.03)',
    '--card-hsl': '13 63% 26%',
    '--card-oklch': 'from #6B2A18 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#4B1A0E',
    '--destructive-foreground-hsl': '12 69% 17%',
    '--destructive-foreground-oklch': 'from #4B1A0E l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFF5F2',
    '--foreground-hsl': '14 100% 97%',
    '--foreground-oklch': 'from #FFF5F2 l c h',
    '--hold-fill': '#F87171',
    '--hold-fill-hsl': '0 91% 71%',
    '--hold-fill-oklch': 'from #F87171 l c h',
    '--input': '#5F2315',
    '--input-hsl': '11 64% 23%',
    '--input-oklch': 'from #5F2315 l c h',
    '--modal-bg': '#4B1A0E',
    '--modal-bg-hsl': '12 69% 17%',
    '--modal-bg-oklch': 'from #4B1A0E l c h',
    '--modal-border': '#5F2315',
    '--modal-border-hsl': '11 64% 23%',
    '--modal-border-oklch': 'from #5F2315 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#5F2315',
    '--muted-foreground': '#F8D9D1',
    '--muted-foreground-hsl': '12 74% 90%',
    '--muted-foreground-oklch': 'from #F8D9D1 l c h',
    '--muted-hsl': '11 64% 23%',
    '--muted-oklch': 'from #5F2315 l c h',
    '--nav-active': '#F87171',
    '--nav-active-hsl': '0 91% 71%',
    '--nav-active-oklch': 'from #F87171 l c h',
    '--nav-bg': '#6B2A18',
    '--nav-bg-hsl': '13 63% 26%',
    '--nav-bg-oklch': 'from #6B2A18 l c h',
    '--popover': '#6B2A18',
    '--popover-foreground': '#FFF5F2',
    '--popover-foreground-hsl': '14 100% 97%',
    '--popover-foreground-oklch': 'from #FFF5F2 l c h',
    '--popover-hsl': '13 63% 26%',
    '--popover-oklch': 'from #6B2A18 l c h',
    '--primary': '#F87171',
    '--primary-foreground': '#4B1A0E',
    '--primary-foreground-hsl': '12 69% 17%',
    '--primary-foreground-oklch': 'from #4B1A0E l c h',
    '--primary-hsl': '0 91% 71%',
    '--primary-oklch': 'from #F87171 l c h',
    '--radius': '16px',
    '--ring': '#F87171',
    '--ring-hsl': '0 91% 71%',
    '--ring-oklch': 'from #F87171 l c h',
    '--secondary': '#5F2315',
    '--secondary-foreground': '#FFF5F2',
    '--secondary-foreground-hsl': '14 100% 97%',
    '--secondary-foreground-oklch': 'from #FFF5F2 l c h',
    '--secondary-hsl': '11 64% 23%',
    '--secondary-oklch': 'from #5F2315 l c h',
    '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)',
    '--streak': '#F87171',
    '--streak-hsl': '0 91% 71%',
    '--streak-oklch': 'from #F87171 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#4B1A0E',
    '--success-foreground-hsl': '12 69% 17%',
    '--success-foreground-oklch': 'from #4B1A0E l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(0 91% 71% / 0.15)',
    '--xp': '#F87171',
    '--xp-bg': '#6B2A18',
    '--xp-bg-hsl': '13 63% 26%',
    '--xp-bg-oklch': 'from #6B2A18 l c h',
    '--xp-hsl': '0 91% 71%',
    '--xp-oklch': 'from #F87171 l c h'
  }
}
